import React from 'react';
import PropTypes from 'prop-types';

import { getShortDateString } from 'dpl/shared/utils/date';
import { getArticlePath } from 'dpl/prismic/utils';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import {
  ARTICLE_TYPES,
  ARTICLE_TYPE_TITLES
} from 'dpl/prismic/article/utils/constants';
import RichText from 'dpl/prismic/components/RichText';

export default function MagazineFrontPageArticleSection({ title, articles }) {
  return (
    <div className="PrismicMagazineFrontPageArticleSection tc tl-l">
      <p className="pb4 bn bb-l b--black mb0 mb4-lg f4 fw-medium">{title}</p>
      <ul>
        {articles.map((article, idx) => (
          <li
            className="pt6 pt4-md pt0-lg bt bn-l b--light-gray mb6 mb4-md row no-gutters"
            key={idx}
          >
            <div className="col-12 col-md-8 col-lg-12 center">
              <a className="db" href={getArticlePath(article)}>
                <p className="mb2 inline-flex align-items-center f2">
                  <span className="fw-medium pink">
                    {ARTICLE_TYPE_TITLES[article.data.article_type] ||
                      'Article'}
                  </span>
                  {article.data.display_date && (
                    <>
                      <span className="mh1">&middot;</span>
                      <span>
                        {getShortDateString(
                          new Date(article.data.display_date)
                        )}
                      </span>
                    </>
                  )}
                </p>
                <p className="fw-medium">
                  {RichText.asText(article.data.title)}
                </p>
              </a>
              {article.data.article_type === ARTICLE_TYPES.WEBINAR &&
                article.data.webinar_rsvp_link &&
                article.data.webinar_rsvp_link.url && (
                  <a
                    className="button button--secondary ph2 pv1 bw1 mt2 dib fw-medium f2"
                    href={article.data.webinar_rsvp_link.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    RSVP
                  </a>
                )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

MagazineFrontPageArticleSection.propTypes = {
  title: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        article_type: PropTypes.oneOf(Object.values(ARTICLE_TYPES)),
        display_date: PropTypes.string,
        title: StructuredTextPropTypes,
        webinar_rsvp_link: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })
  ).isRequired
};
